import { createThunk, model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';
import { format, isToday, parseJSON } from 'date-fns';

import { Api } from '@api';

export class Message extends Model({
  id: types.identifierNumber,
  message: types.string,
  isIncome: types.boolean,
  sendTime: types.string,
  userId: types.integer,

  hasError: false,
}) {
  get formattedTime() {
    const date = parseJSON(this.sendTime);
    const formatVariant = isToday(date) ? 'HH:mm' : 'PP HH:mm';

    return format(date, formatVariant);
  }

  setHasError(value: boolean) {
    this.hasError = value;
  }

  retry = createThunk(() => {
    return async function retry(this: Message) {
      if (this.hasError) {
        // Find a way to replace Message Identifier with 'addedMessageId' from response
        // FIXME: https://github.com/mobxjs/mobx-state-tree/issues/887
        await Api.Messaging.sendMessage({
          recipientId: this.userId,
          sendTime: this.sendTime,
          message: this.message,
        });

        this.setHasError(false);
      }
    };
  });
}

export const MessageModel = model(Message);
